import {
    addFdListener,
    FreezeDryItemTypes,
    EventTypes,
    lazyCreateOrUpdateMainWindowItem,
} from 'owa-freeze-dry';
import { createMainWindowItem } from './createMainWindowItem';
import { logGreyError } from 'owa-analytics';
import { type MainWindow } from 'owa-freeze-dry';
import { getMailboxInfoFromFolderId } from 'owa-mail-mailboxinfo';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

function handlePersistScrollPosition() {
    const mainWindow: Partial<MainWindow> = createMainWindowItem();
    const mailboxInfo = mainWindow?.folderId
        ? getMailboxInfoFromFolderId(mainWindow.folderId)
        : getModuleContextMailboxInfo();

    try {
        if (mainWindow) {
            lazyCreateOrUpdateMainWindowItem.importAndExecute(mainWindow);
        } else {
            logGreyError('FreezeDryPersistScrollPositionError_MainWindowUndefined', mailboxInfo);
        }
    } catch (e) {
        logGreyError('FreezeDryPersistScrollPositionError', mailboxInfo, e as Error);
    }
}

// Add the listener to 'fdEventManager'
export function initializePersistMailListener(): void {
    addFdListener(EventTypes.Persist, FreezeDryItemTypes.MainWindow, handlePersistScrollPosition);
}
